var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2687 13.6667L12.0351 10.6707L15.2687 13.6667ZM13.827 6.66666C13.827 8.16955 13.1815 9.61089 12.0325 10.6736C10.8834 11.7363 9.32496 12.3333 7.69996 12.3333C6.07496 12.3333 4.51651 11.7363 3.36746 10.6736C2.21841 9.61089 1.57288 8.16955 1.57288 6.66666C1.57288 5.16376 2.21841 3.72242 3.36746 2.65972C4.51651 1.59701 6.07496 0.999989 7.69996 0.999989C9.32496 0.999989 10.8834 1.59701 12.0325 2.65972C13.1815 3.72242 13.827 5.16376 13.827 6.66666V6.66666Z",
    stroke: "#000000",
    strokeWidth: 1.33333,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/icon--search.eec4e8c8e9dc94ea5f0e6364d7f221a2.svg";
export { ForwardRef as ReactComponent };